export const DashboardType={
    INTERVIEWER:"iv-interviewer-web-app",
    OPS:"iv-ops-web-app",
    CLIENT:"iv-client-web-app"
  }

export function toCamelCase(str) {
  const words = str.split("_");

  const formattedWords = words.map((word) => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return formattedWords.join(" ");
}